import classes from "./Input.module.css";
import React from "react";

const Input = React.forwardRef((props,ref) => {
  return (
    <div className={classes.input}>
      <label htmlFor={props.input.id}>{props.label}</label>
      <input ref={ref} {...props.input} />
    </div>
  );
});

export default Input;

//the props.input insures that all the key value pairs in this input object that gets passed form
//input props.input gets passed on as props as input
